import * as zod from 'zod';

import type { CameraDevice } from '@sb/messenger/auto_generated/messenger/camera_bot_service';

export const CameraState = zod.object({
  kind: zod.literal('Camera'),
  connected: zod.boolean(),
  cameraDevice: zod.custom<CameraDevice>().optional(),
  // Set by Camera.ts when the device stays CONNECTED with no published
  // streams past STREAM_STARTUP_TIMEOUT_MS. Lets the UI distinguish a
  // brief warm-up from a stuck stream publisher.
  streamStartupExpired: zod.boolean().optional(),
});

export type CameraState = zod.infer<typeof CameraState>;
